import httpClient from "../../axios";
import { ENV } from "../../env";

export const API_URL_DAS = `https://www.${
  ENV !== "production" ? (ENV === "development" ? "dev" : ENV) + "-" : ""
}manage-mii.uk/api/das/business-card`;

export const API_URL_WEARABLES = `https://www.${
  ENV !== "production" ? (ENV === "development" ? "dev" : ENV) + "-" : ""
}manage-mii.uk/api/wearables`;

const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/",
  x: "https://www.x.com/",
  linkedin: "https://www.linkedin.com/in/",
  instagram: "https://www.instagram.com/",
  whatsapp: "https://wa.me/"
};

const getBusinessCard = async (serial) => {
  try {
    const response = await httpClient.get(
      API_URL_WEARABLES + `/${serial}/business-card`
    );

    if (response.data.social) {
      response.data.social = Object.keys(response.data.social).map((key) => {
        const socialValue = response.data.social[key];
        let link;

        if (socialValue.includes("http")) {
          link = socialValue;
        } else {
          if (key === "linkedin" && socialValue.includes("/in/")) {
            const cleanValue = socialValue
              .replace(/^\/in\//, "")
              .replace(/^in\//, "");
            link = SOCIAL_LINKS[key] + cleanValue;
          } else {
            link = SOCIAL_LINKS[key] + socialValue;
          }
        }

        return {
          name: key,
          link
        };
      });
    }

    return response.data;
  } catch (error) {
    const response = await httpClient.get(API_URL_DAS + `/${serial}`);

    if (response.data?.promoReadyData?.social) {
      response.data.promoReadyData.social = Object.keys(
        response.data.promoReadyData.social
      ).map((key) => {
        if (response.data.promoReadyData.social[key]) {
          const socialValue = response.data.promoReadyData.social[key];
          let link;

          if (socialValue.includes("http")) {
            link = socialValue;
          } else {
            if (key === "linkedin" && socialValue.includes("/in/")) {
              const cleanValue = socialValue
                .replace(/^\/in\//, "")
                .replace(/^in\//, "");
              link = SOCIAL_LINKS[key] + cleanValue;
            } else {
              link = SOCIAL_LINKS[key] + socialValue;
            }
          }

          return {
            name: key,
            link
          };
        }
        return null;
      });
    }

    return response.data?.promoReadyData;
  }
};

const businessCardService = {
  getBusinessCard
};

export default businessCardService;
